module.exports = __webpack_public_path__ + "static/media/PortraitCover.c8ddc278.jpg";